import type { BoardEntry } from '../lib/match-snapshot';

/** Play uses the server's allowed-board view for every game's status. */
export function BoardTurnStatus({ entry, mine, opponent, spectator }: {
  entry: BoardEntry; mine: boolean; opponent: boolean; spectator: boolean;
}) {
  const deal = entry.game_id === 'BridgeNT' && (entry.state as {phase?: string}).phase === 'awaiting_hands';
  const status = entry.result !== null ? 'finished' : deal ? 'dealing' : spectator ? 'spectator' : mine ? 'mine' : opponent ? 'opponent' : 'waiting';
  const text = {finished: '終局', dealing: '配牌中', spectator: '観戦中', mine: 'あなたの番', opponent: '相手の番', waiting: '手番待ち'}[status];
  return <span className={mine && status === 'mine' ? 'seat-turn' : 'sr-only'} data-testid="board-turn-status" data-status={status} role="status">{text}</span>;
}
